<div class="slider-header">
    <div class="header ion-text-center">
        {{title}}
    </div>
    <hr>
    <div class="view-all">
        View all
    </div>
</div>